import {Controller} from "stimulus";
import flatpickr from "flatpickr";
import type {Options} from "flatpickr/dist/types/options";
import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr";
import {autoResizeSelect} from "src/common/form";
import {flatpickrClosedHook} from "../../../../../../../frontend/src/admin/components/flatpickr_hooks";
import * as chrono from "chrono-node";

export default class DateController extends Controller<HTMLInputElement> {
  datePicker?: flatpickr.Instance;

  static values = {
    options: {type: Object, default: {}},
  };

  declare optionsValue: Options;

  connect() {
    this.initFlatpicker();
    this.element.addEventListener("turbo:morph-element", this.refreshFlatPicker);
  }

  disconnect() {
    if (this.datePicker && this.datePicker.destroy) this.datePicker.destroy();
    this.element.removeEventListener("turbo:morph-element", this.refreshFlatPicker);
  }

  initFlatpicker = () => {
    if (this.datePicker && this.datePicker.destroy) this.datePicker.destroy();
    this.datePicker = flatpickr(this.element, {
      enableTime: false,
      altInput: true,
      allowInput: true,
      altInputClass: [...Array.from(this.element.classList)].join(" "),
      altFormat: "D, j M Y",
      dateFormat: "Y-m-d",
      maxDate: this.element.getAttribute("max")?.toString(),
      minDate: this.element.getAttribute("min")?.toString(),
      monthSelectorType: "dropdown",
      locale: {firstDayOfWeek: 1}, // start week on Monday
      parseDate: (datestr, _format) => {
        return chrono.en.GB.parseDate(datestr) as Date;
      },
      onReady(_dates, _currentDateString, {_input}) {
        _input.setAttribute(
          "aria-labelledby",
          this.element.getAttribute("aria-labelledby")
        );
      },
      onOpen: (_dates, _currentDateString, instance) => {
        autoResizeSelect(instance.monthElements[0] as HTMLSelectElement);
      },
      onMonthChange: (_dates, _currentDateString, instance) => {
        setTimeout(() => autoResizeSelect(instance.monthElements[0] as HTMLSelectElement));
      },
      onClose: (_selectedDates, _dateStr, _instance) => {
        flatpickrClosedHook(this.element);
      },
      plugins: [
        ShortcutButtonsPlugin({
          button: [
            {label: "Clear", attributes: {class: "secondary"}},
            {label: "Today", attributes: {class: "secondary"}},
          ],
          onClick: (index: number, fp: any) => {
            switch (index) {
            case 0:
              fp.clear();
              fp.close();
              break;
            case 1:
              fp.setDate(new Date());
              break;
            }
          },
        }),
      ],
      ...this.optionsValue,
    });
  };

  refreshFlatPicker = (e: Event) => {
    if (e.target === this.element) setTimeout(this.initFlatpicker);
  };
}
